import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59791025"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "card card-bordered col-md-6 mt-5" }
const _hoisted_3 = {
  class: "card-header",
  style: {"margin-top":"20px"}
}
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "card card-bordered col-md-6 mt-5" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, "Newly Approved Offers")
], -1))
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = { class: "table align-middle table-row-dashed fs-7 gy-5 dataTable no-footer" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0" }, [
    /*#__PURE__*/_createElementVNode("td", null, "Date"),
    /*#__PURE__*/_createElementVNode("td", null, "ID"),
    /*#__PURE__*/_createElementVNode("td", null, "Preview"),
    /*#__PURE__*/_createElementVNode("td", null, "Offer Name"),
    /*#__PURE__*/_createElementVNode("td", null, "OS"),
    /*#__PURE__*/_createElementVNode("td", null, "Link")
  ])
], -1))
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dw_loader = _resolveComponent("dw-loader")!
  const _component_option_selector = _resolveComponent("option-selector")!
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_dw_loader, { active: _ctx.busy }, null, 8, ["active"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_option_selector, {
            modelValue: _ctx.chartFilter,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.chartFilter) = $event)),
            label: "Performance Report",
            options: _ctx.chartOptions
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_apexchart, {
            type: "line",
            options: _ctx.generalPerformance.options,
            series: _ctx.generalPerformance.series
          }, null, 8, ["options", "series"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("table", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.records, (r) => {
                  return (_openBlock(), _createElementBlock("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(r.created_at), 1),
                    _createElementVNode("td", null, _toDisplayString(r.id), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("a", {
                        class: "text-dark fw-bolder text-hover-primary mb-1 fs-6",
                        href: r.preview_url,
                        target: "_blank"
                      }, _toDisplayString(`Preview`), 8, _hoisted_11)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(r.name), 1),
                    _createElementVNode("td", null, _toDisplayString(r.platform), 1),
                    _createElementVNode("td", null, [
                      _createVNode(_component_router_link, {
                        class: "btn btn-link",
                        to: {name:'offer-view', params: {id: r.id}}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_12
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ])
                  ]))
                }), 256))
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}